import { render } from "./ModalTransactionInfo.vue?vue&type=template&id=4d9abe9f&scoped=true&ts=true"
import script from "./ModalTransactionInfo.vue?vue&type=script&lang=ts"
export * from "./ModalTransactionInfo.vue?vue&type=script&lang=ts"

import "./ModalTransactionInfo.vue?vue&type=style&index=0&id=4d9abe9f&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9abe9f"]])

export default __exports__